import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/hotel-card/rating-star.svg")